import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularArrowUp: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_arrow-up"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="arrow-up icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M5.81798 12.182C6.01324 12.3772 6.32983 12.3772 6.52509 12.182L11.3284 7.37865L11.3284 11.1213C11.3284 11.3974 11.5522 11.6213 11.8284 11.6213C12.1045 11.6213 12.3284 11.3974 12.3284 11.1213L12.3284 6.17154C12.3284 5.8954 12.1045 5.67154 11.8284 5.67154L6.87864 5.67154C6.6025 5.67154 6.37864 5.8954 6.37864 6.17154C6.37864 6.44769 6.6025 6.67154 6.87864 6.67154L10.6213 6.67154L5.81798 11.4748C5.62272 11.6701 5.62272 11.9867 5.81798 12.182Z" />
      </svg>
    </span>
  );
};

export { RegularArrowUp };
